export class ImageViewerValues {
    private _imageBase64: string;
    private _fileName: string;
    private _title?: string;

    constructor(imageBase64: string, fileName?: string, title?: string) {
        this.imageBase64 = imageBase64;
        this.fileName = fileName;
        this.title = title;
    }

    public get imageBase64(): string {
        return this._imageBase64;
    }

    private set imageBase64(value: string) {
        this._imageBase64 = value;
    }

    public get fileName(): string {
        return this._fileName;
    }

    private set fileName(value: string) {
        this._fileName = value;
    }

    public get title(): string {
        return this._title ?? this.fileName;
    }

    private set title(value: string) {
        this._title = value;
    }

    /**
     * Implement toJSON so that the info is serialized in the desired format.
     * @returns any
     */
    public toJSON(): any {
        return {
            imageBase64: this._imageBase64,
            fileName: this.fileName,
            title: this.title
        };
    }
}
